// src/components/Layout/Sidebar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { Badge } from 'react-bootstrap';
import {useSidebar} from "../../App";
import Gravatar from "react-gravatar";

const Sidebar = () => {
    const { user } = useAuthStore();
    const { collapsed, setCollapsed } = useSidebar();

    // Menu položky s ikonami, názvy a případnými badgemi
    const menuItems = [
        { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Přehled' },
        { path: '/websites', icon: 'fa-globe', label: 'Weby' },
        { path: '/teams', icon: 'fa-users', label: 'Týmy' },
        { path: '/reports', icon: 'fa-chart-bar', label: 'Reporty' },
        { path: '/security', icon: 'fa-shield-alt', label: 'Bezpečnost' },//, badge: 2
        { path: '/backups', icon: 'fa-database', label: 'Zálohy' },
        { path: '/notifications', icon: 'fa-bell', label: 'Notifikace'},
        { path: '/integrations', icon: 'fa-plug', label: 'Integrace' },
        { path: '/settings', icon: 'fa-cog', label: 'Nastavení' },
        //{ path: '/api-documentation', icon: 'fa-book', label: 'API Dokumentace' },
    ];

    return (
        <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-header">
                <div className="logo-container">
                    <i className="fas fa-display text-primary me-2"></i>
                    {!collapsed && <h3>WP Monitor</h3>}
                </div>
                <button
                    className="collapse-btn"
                    onClick={() => setCollapsed(!collapsed)}
                    title={collapsed ? 'Rozbalit menu' : 'Sbalit menu'}
                >
                    <i className={`fas ${collapsed ? 'fa-angle-right' : 'fa-angle-left'}`}></i>
                </button>
            </div>

            <div className="sidebar-menu">
                <ul>
                    {menuItems.map((item, index) => (
                        <li key={index}>
                            <NavLink
                                to={item.path}
                                className={({isActive}) => isActive ? 'active' : ''}
                                title={collapsed ? item.label : ''}
                            >
                                <i className={`fas ${item.icon}`}></i>
                                {!collapsed && <span>{item.label}</span>}
                                {!collapsed && item.badge && (
                                    <Badge bg="danger" pill className="ms-auto">
                                        {item.badge}
                                    </Badge>
                                )}
                                {collapsed && item.badge && (
                                    <Badge bg="danger" pill className="badge-collapsed">
                                        {item.badge}
                                    </Badge>
                                )}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>

            {user && (
                <div className="sidebar-footer">
                    <div className="user-info">
                        <div className="user-avatar">
                            <Gravatar className="avatar-circle avatar-sm me-2"
                                      email={user.email} size={100} rating="pg" default="monsterid"
                            />
                        </div>
                        {!collapsed && (
                            <div className="user-details">
                                <h6 className="mb-0">{user.firstName} {user.lastName}</h6>
                                <span className="text-white-50 text-truncate small">{user.email}</span>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sidebar;